// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__a5u4L","questions":"styles_questions__5rNiV","faq__img":"styles_faq__img__hEidF"};